var Anhui = "อานฮุย";
var Beijing = "ปักกิ่ง";
var Chongqing = "ฉงชิ่ง";
var Fujian = "ฝูเจี้ยน";
var Gansu = "กานซู";
var Guangdong = "กวางตุ้ง";
var Guangxi = "กว่างซี";
var Guizhou = "กุ้ยโจว";
var Hainan = "ไห่หนาน";
var Hebei = "เหอเป่ย์";
var Heilongjiang = "เฮย์หลงเจียง";
var Henan = "เหอหนาน";
var Hubei = "หูเป่ย์";
var Hunan = "หูหนาน";
var Jiangsu = "เจียงซู";
var Jiangxi = "เจียงซี";
var Jilin = "จี๋หลิน";
var Liaoning = "เหลียวหนิง";
var Ningxia = "หนิงเซี่ย";
var Qinghai = "ชิงไห่";
var Shaanxi = "ฉ่านซี";
var Shandong = "ซานตง";
var Shanghai = "เซี่ยงไฮ้";
var Shanxi = "ชานซี";
var Sichuan = "เสฉวน";
var Tianjin = "เทียนจิน";
var Tibet = "ธิเบต";
var Xinjiang = "ซินเจียง";
var Yunnan = "ยูนนาน";
var Zhejiang = "เจ้อเจียง";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "มองโกเลียใน",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
